import { useActiveSubscription } from "~/store/subscription/subscription"

export default defineNuxtPlugin(async (nuxtApp) => {
  await useActiveSubscription().init()
})